/* Plumeria Luxe : aides à l'achat.
   1. Blocs de la fiche produit qui suivent la variante choisie ([data-luxe-sync] : points, livraison, alerte stock) ;
   2. jauge « livraison offerte » de la fiche produit, recalculée quand le panier change ;
   3. étoiles des avis sous le prix des cartes produits ;
   4. « Vus récemment » (section luxe-recent) ;
   5. quiz « Trouver mon bijou » (section luxe-quiz) ;
   6. la page ne se décale jamais en largeur (éditeur mobile, carrousels). */
(function () {
  'use strict';
  if (window.luxeBoutiquePret) return;
  window.luxeBoutiquePret = true;

  // 6. Un défilement horizontal de la page (scrollIntoView d'un carrousel, éditeur Shopify) la ramène à gauche.
  window.addEventListener('scroll', function () {
    if (window.scrollX !== 0) window.scrollTo(0, window.scrollY);
  }, { passive: true });

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(cents) { return (Math.max(0, cents) / 100).toFixed(2).replace('.', ',') + '€'; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* ---------- 1. Blocs qui suivent la variante ---------- */
  document.addEventListener('variant:update', function (event) {
    var html = event.detail && event.detail.data && event.detail.data.html;
    if (!html || !html.querySelector) return;
    document.querySelectorAll('[data-luxe-sync]').forEach(function (el) {
      var fresh = html.querySelector('[data-luxe-sync="' + el.getAttribute('data-luxe-sync') + '"]');
      if (fresh) el.replaceWith(document.importNode(fresh, true));
    });
    if (lastCart) updateGauges(lastCart.total_price);
  });

  /* ---------- 2. Jauge de livraison (fiche produit) ---------- */
  var lastCart = null;
  function updateGauges(cartTotal) {
    document.querySelectorAll('[data-luxe-gauge]').forEach(function (g) {
      var goal = Number(g.getAttribute('data-goal'));
      var price = Number(g.getAttribute('data-price'));
      var cart = cartTotal == null ? Number(g.getAttribute('data-cart')) : cartTotal;
      var after = cart + price;
      var text;
      if (cart >= goal) text = 'La livraison vous est offerte.';
      else if (after >= goal) text = 'Avec ce bijou, la livraison vous est offerte.';
      else if (cart === 0) text = 'Livraison offerte dès ' + money(goal).replace(',00€', ' €') + ' : plus que ' + money(goal - after) + ' après ce bijou.';
      else text = 'Avec ce bijou, plus que ' + money(goal - after) + ' pour la livraison offerte.';
      var t = g.querySelector('[data-luxe-gauge-text]');
      if (t && t.textContent !== text) t.textContent = text;
      var fill = g.querySelector('[data-luxe-gauge-fill]');
      if (fill) fill.style.width = Math.min(100, (after / goal) * 100) + '%';
      var now = g.querySelector('[data-luxe-gauge-now]');
      if (now) now.style.width = Math.min(100, (cart / goal) * 100) + '%';
      g.classList.toggle('is-complete', after >= goal);
    });
  }
  document.addEventListener('cart:update', function (event) {
    var cart = event.detail && event.detail.resource;
    if (cart && typeof cart.total_price === 'number') {
      lastCart = cart;
      updateGauges(cart.total_price);
    } else {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { lastCart = c; updateGauges(c.total_price); })
        .catch(function () {});
    }
  });

  /* ---------- 3. Étoiles sous le prix des cartes ---------- */
  function placeRatings(scope) {
    (scope || document).querySelectorAll('product-card [data-luxe-rating]').forEach(function (r) {
      var card = r.closest('product-card');
      var content = card && card.querySelector('.product-card__content');
      if (!content) return;
      r.hidden = false;
      r.removeAttribute('data-luxe-rating');
      r.classList.add('is-placed');
      content.appendChild(r);
    });
  }

  /* ---------- 4. Vus récemment ---------- */
  var RECENT = 'plumeria-vus';
  var cache = {};
  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }
  function readRecent() {
    try { var l = JSON.parse(localStorage.getItem(RECENT) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function miniCard(p, url) {
    var prices = p.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; });
    var from = prices.length ? Math.min.apply(null, prices) : p.price;
    var many = prices.length > 1 && Math.max.apply(null, prices) !== from;
    return (
      '<li class="luxe-mini">' +
      '<a class="luxe-mini__media" href="' + esc(url || p.url) + '">' +
      (p.featured_image ? '<img src="' + esc(img(p.featured_image, 480)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
      (p.available ? '' : '<span class="luxe-mini__soldout">Bientôt de retour</span>') +
      '</a>' +
      '<a class="luxe-mini__name" href="' + esc(url || p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="luxe-mini__price">' + (many ? 'À partir de ' : '') + money(from) + '</span>' +
      '</li>'
    );
  }
  function initRecent() {
    document.querySelectorAll('[data-luxe-recent]').forEach(function (section) {
      if (section.dataset.ready) return;
      section.dataset.ready = '1';
      var current = section.getAttribute('data-current') || '';
      var list = readRecent().filter(function (h) { return h !== current; });
      if (current) {
        try { localStorage.setItem(RECENT, JSON.stringify([current].concat(list).slice(0, 16))); } catch (e) {}
      }
      var max = Number(section.getAttribute('data-max')) || 8;
      var handles = list.slice(0, max);
      if (!handles.length) return;
      Promise.all(handles.map(fetchProduct)).then(function (products) {
        var found = products.filter(Boolean);
        if (!found.length) return;
        section.querySelector('[data-luxe-recent-list]').innerHTML = found.map(function (p) { return miniCard(p); }).join('');
        section.hidden = false;
      });
    });
  }

  /* ---------- 5. Quiz « Trouver mon bijou » ---------- */
  var STYLES = [
    { id: 'lumiere', label: 'Un point de lumière', hint: 'Stud, labret, embout', types: ['Stud nez', 'Labret', 'Embout piercing nez'] },
    { id: 'anneau', label: 'Un anneau', hint: 'Fin ou travaillé', types: ['Anneau', 'Anneau nez', 'Anneau nombril'] },
    { id: 'barre', label: 'Une barre ou une banane', hint: 'Droite ou courbée', types: ['Micro-banane', 'Barbell industriel', 'Barbell langue', 'Barbell téton', 'Barbell intime', 'Banane nombril'] },
    { id: 'fer', label: 'Un fer à cheval', hint: 'Septum, narine', types: ['Fer à cheval nez'] },
    { id: 'charm', label: 'Un charm à suspendre', hint: 'Sur un anneau', types: ['Charm'] }
  ];
  var HORS_QUIZ = ['Accessoire', 'Box mystère', 'Carte cadeau', 'Option cadeau', 'Tige piercing nez'];
  function colorMatch(value, color) {
    var v = String(value).toLowerCase();
    if (color === 'or') return /\bor\b|dor/.test(v) && !/rose/.test(v);
    if (color === 'argent') return /argent|silver|titane/.test(v);
    return true;
  }
  function quizVariant(p, color) {
    return p.variants.filter(function (v) {
      return v.available && (color === 'tout' || [v.option1, v.option2, v.option3].some(function (o) { return o && colorMatch(o, color); }));
    })[0];
  }

  function initQuiz() {
    document.querySelectorAll('[data-luxe-quiz]').forEach(function (quiz) {
      if (quiz.dataset.ready) return;
      quiz.dataset.ready = '1';
      var state = { zone: null, collection: null, label: '', style: null, color: null, products: null };
      var steps = quiz.querySelectorAll('[data-step]');
      var progress = quiz.querySelector('[data-luxe-quiz-progress]');

      function show(name) {
        steps.forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; });
        var n = { zone: 1, sous: 1, style: 2, couleur: 3, resultat: 4 }[name] || 1;
        if (progress) progress.style.width = (n / 4) * 100 + '%';
        var title = quiz.querySelector('[data-step="' + name + '"] [data-focus]');
        if (title) { title.setAttribute('tabindex', '-1'); title.focus({ preventScroll: true }); }
        var top = quiz.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }

      function loadCollection(handle) {
        state.products = null;
        return fetch(root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            /* products.json : prix en euros (texte) et photos dans images[] → même forme que /products/x.js */
            state.products = (d.products || []).map(function (p) {
              var variants = p.variants.map(function (v) {
                return { id: v.id, available: v.available, price: Math.round(parseFloat(v.price) * 100), option1: v.option1, option2: v.option2, option3: v.option3, image: v.featured_image ? v.featured_image.src : '' };
              });
              return {
                handle: p.handle, title: p.title, product_type: p.product_type, url: root + 'products/' + p.handle,
                featured_image: p.images && p.images[0] ? p.images[0].src : '',
                available: variants.some(function (v) { return v.available; }),
                price: variants.length ? variants[0].price : 0,
                variants: variants
              };
            }).filter(function (p) {
              return HORS_QUIZ.indexOf(p.product_type) === -1 && p.available;
            });
          });
      }

      function renderStyles() {
        var box = quiz.querySelector('[data-luxe-quiz-styles]');
        var found = STYLES.filter(function (s) {
          return state.products.some(function (p) { return s.types.indexOf(p.product_type) !== -1; });
        });
        box.innerHTML = found.map(function (s) {
          return '<button type="button" class="luxe-quiz__choice" data-style="' + s.id + '"><span class="luxe-quiz__choice-title">' + esc(s.label) + '</span><span class="luxe-quiz__choice-hint">' + esc(s.hint) + '</span></button>';
        }).join('') + '<button type="button" class="luxe-quiz__choice" data-style="tout"><span class="luxe-quiz__choice-title">Je veux tout voir</span><span class="luxe-quiz__choice-hint">Toutes les formes</span></button>';
        quiz.querySelector('[data-luxe-quiz-zone-label]').textContent = state.label;
        show('style');
      }

      function renderResults() {
        var style = STYLES.filter(function (s) { return s.id === state.style; })[0];
        var pool = state.products.filter(function (p) { return !style || style.types.indexOf(p.product_type) !== -1; });
        var picks = pool.map(function (p) { return { p: p, v: quizVariant(p, state.color) }; }).filter(function (x) { return x.v; });
        var note = '';
        if (!picks.length) {
          picks = pool.map(function (p) { return { p: p, v: quizVariant(p, 'tout') }; }).filter(function (x) { return x.v; });
          note = "Cette forme n'existe pas encore dans cette couleur : voici toutes ses finitions.";
        }
        var list = quiz.querySelector('[data-luxe-quiz-results]');
        list.innerHTML = picks.slice(0, 8).map(function (x) {
          /* Photo de la couleur choisie quand la variante en a une */
          var shown = x.v.image ? Object.assign({}, x.p, { featured_image: x.v.image }) : x.p;
          return miniCard(shown, root + 'products/' + x.p.handle + '?variant=' + x.v.id);
        }).join('');
        quiz.querySelector('[data-luxe-quiz-note]').textContent = note;
        quiz.querySelector('[data-luxe-quiz-count]').textContent =
          picks.length + (picks.length > 1 ? ' bijoux pensés pour vous' : ' bijou pensé pour vous');
        var all = quiz.querySelector('[data-luxe-quiz-all]');
        all.href = root + 'collections/' + state.collection;
        all.textContent = 'Voir toute la collection ' + state.label.toLowerCase();
        show('resultat');
      }

      quiz.addEventListener('click', function (event) {
        var zone = event.target.closest('[data-zone]');
        if (zone) {
          var sub = zone.getAttribute('data-sous');
          if (sub) {
            quiz.querySelectorAll('[data-sous-groupe]').forEach(function (g) { g.hidden = g.getAttribute('data-sous-groupe') !== sub; });
            quiz.querySelector('[data-luxe-quiz-sous-titre]').textContent = zone.getAttribute('data-question');
            show('sous');
            return;
          }
          state.collection = zone.getAttribute('data-zone');
          state.label = zone.getAttribute('data-label') || zone.textContent.trim();
          zone.classList.add('is-loading');
          loadCollection(state.collection).then(function () {
            zone.classList.remove('is-loading');
            renderStyles();
          }).catch(function () { zone.classList.remove('is-loading'); });
          return;
        }
        var style = event.target.closest('[data-style]');
        if (style) { state.style = style.getAttribute('data-style'); show('couleur'); return; }
        var color = event.target.closest('[data-color]');
        if (color) { state.color = color.getAttribute('data-color'); renderResults(); return; }
        var back = event.target.closest('[data-back]');
        if (back) { show(back.getAttribute('data-back')); return; }
        if (event.target.closest('[data-restart]')) { state = { zone: null, collection: null, label: '', style: null, color: null, products: null }; show('zone'); }
      });
    });
  }

  function init() {
    placeRatings(document);
    initRecent();
    initQuiz();
    updateGauges(null);
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        if (document.querySelector('product-card [data-luxe-rating]')) placeRatings(document);
        if (document.querySelector('[data-luxe-recent]:not([data-ready]), [data-luxe-quiz]:not([data-ready])')) { initRecent(); initQuiz(); }
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
